module.exports = __webpack_public_path__ + "static/media/warning.39b51f58.svg";